import type { Vehicle } from '../../Entities/Vehicle/Vehicle.entity';

export const canShowReserve = (vehicle: Vehicle, reserveNowFlag: boolean) =>
  reserveNowFlag &&
  !vehicle.ecom.isEcom &&
  vehicle.details.status === 'active' &&
  vehicle?.pricing?.package?.reservation === true;
